<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div class="secondstep">
        <el-form
          :model="ruleForm"
          :rules="rules"
          class="backgroundForm"
          ref="ruleForm"
          label-width="120px"
        >
          <el-form-item label="活动名称:" required>
            <!-- prop="activityName" 活动名称 -->
            <el-input
              v-model="ruleForm.activityName"
              maxlength="50"
              show-word-limit
              placeholder="积分任务的展示名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 400px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="activityTimeValue = []"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
              <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象：" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="isStartEdit"
              @change="handleActivityObj"
              style="margin-right: 16px"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~"
            >
              <el-button slot="reference" disabled>{{
                peopleList.length == 0
                  ? "选择人群"
                  : `已选${peopleList.length}个`
              }}</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户："
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #999;
                "
              >
                <span>新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="
              nowType == 'look' ||
              (nowType == 'edit' && activityData.status == 2)
            "
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>
          <!-- Note------关注店铺 -->
          <el-form-item label="活动条件:" prop="partner">
            <el-checkbox v-model="ruleForm.isFollow" :disabled="isStartEdit">
              关注店铺后方可参与活动
            </el-checkbox>
          </el-form-item>
          <el-form-item label="活动强制结束:" prop="test">
            <el-checkbox
              v-model="ruleForm.cutActivityWhileNoPrize"
              :disabled="isStartEdit"
              >全部奖品领取完强制结束活动</el-checkbox
            >
            <span class="warningTitele">
              <i class="el-alert__icon el-icon-info" style="color: #ebaa3c"></i>
              注：勾选后，在打榜截止时间后，当所有奖品发放完毕后，活动会自动结束
            </span>
          </el-form-item>
          <el-form-item label="背景设置:" prop="partner">
            <el-radio v-model="picType1" :label="0" :disabled="isStartEdit"
              >系统预设</el-radio
            >
            <el-radio v-model="picType1" :label="1" :disabled="isStartEdit"
              >自定义</el-radio
            >
            <div class="m-b-24" v-show="picType1 == 0">
              <img
                src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_C/default-hit.png"
                class="avatar"
              />
            </div>
            <div v-show="picType1 == 1">
              <div class="imgUpload m-b-20">
                <el-upload
                  class="avatar-uploader"
                  action=""
                  multiple
                  :limit="1"
                  :before-upload="beforeUpload1"
                  accept=".jpg,.png"
                  :disabled="isStartEdit"
                >
                  <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div style="color: #999999; margin-bottom: 10px">
                  <p class="my-mg-10">建议上传尺寸：750px*1820px</p>
                  <p class="my-mg-10">图片大小：2MB以内</p>
                  <p class="my-mg-10">格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="邀请文案:" prop="partner">
            <el-input
              v-model="ruleForm.copywriting"
              show-word-limit
              style="width: 405px"
            ></el-input>
          </el-form-item>
          <el-form-item label="打榜截止时间:" prop="partner">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="ruleForm.deadline"
              type="datetime"
              placeholder="选择日期时间"
              :disabled="isStartEdit"
            >
            </el-date-picker>
            打榜截止后，才可以领取奖品
          </el-form-item>
          <el-form-item label="奖品设置:" prop="setPrize">
            <el-button @click="addTask" :disabled="isStartEdit"
              >+添加任务</el-button
            >
            <div></div>
          </el-form-item>
          <!-- 试用商品显示 -->
          <el-form-item label="" prop="setPrize">
            <div class="wide" v-for="(item, index) in trialList" :key="index">
              <div class="rulebox_flex">
                <div v-if="item.pointActivityPrizeDTOList.ladderType == 1">
                  阶梯{{ index + 1 }}：排名第{{
                    item.pointActivityPrizeDTOList.section
                  }}名
                </div>
                <div v-if="item.pointActivityPrizeDTOList.ladderType == 2">
                  阶梯{{ index + 1 }}：排名第{{
                    item.pointActivityPrizeDTOList.sectionOne
                  }}
                  ~ {{ item.pointActivityPrizeDTOList.sectionTwo }} 名
                </div>
                <div class="posi">
                  <el-button
                    style="width: 50px"
                    @click="edit(item, index)"
                    :disabled="isStartEdit"
                    >编辑</el-button
                  >
                  <el-button
                    style="width: 50px"
                    @click="deletePacket(index)"
                    :disabled="isStartEdit"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="rulebox_flex">
                <div>
                  邀请限制： {{ item.pointActivityPrizeDTOList.inviteLimit }}
                </div>
              </div>
              <div class="rulebox_flex">
                <!-- 实物奖品显示 -->
                <div
                  v-if="
                    item.pointActivityPrizeDTOList.prizeType == 3 ||
                    item.pointActivityPrizeDTOList.prizeType == 10
                  "
                >
                  奖品内容：{{ item.pointActivityPrizeDTOList.title }}
                </div>
                <!-- 积分值 -->
                <div v-if="item.pointActivityPrizeDTOList.prizeType == 4">
                  奖品内容：<span style="color: #2670fb">{{
                    item.pointActivityPrizeDTOList.price
                  }}</span
                  >店铺积分
                </div>
                <!-- 支付红包 -->
                <div v-if="item.pointActivityPrizeDTOList.prizeType == 8">
                  奖品内容：<span style="color: #2670fb"
                    >{{ item.pointActivityPrizeDTOList.price }}元</span
                  >支付红包
                </div>
                <!-- 优惠券 -->
                <div v-if="item.pointActivityPrizeDTOList.prizeType == 1">
                  奖品内容：<span style="color: #2670fb"
                    >{{ item.pointActivityPrizeDTOList.price }}元</span
                  >优惠券
                </div>
              </div>
              <div
                class="rulebox_flex"
                v-if="item.pointActivityPrizeDTOList.prizeType == 3"
              >
                <div>
                  奖品图片：
                  <img
                    style="
                      width: 80px;
                      height: 80px;
                      vertical-align: top;
                      border-radius: 4px 4px 4px 4px;
                    "
                    :src="item.pointActivityPrizeDTOList.logo"
                    alt=""
                    class="date_icon3"
                  />
                </div>
              </div>
              <div
                class="rulebox_flex"
                v-if="item.pointActivityPrizeDTOList.prizeType == 10"
              >
                <div>
                  奖品图片：
                  <img
                    style="
                      width: 80px;
                      height: 80px;
                      vertical-align: top;
                      border-radius: 4px 4px 4px 4px;
                    "
                    :src="item.pointActivityPrizeDTOList.logo"
                    alt=""
                    class="date_icon3"
                  />
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动规则:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
                :disabled="backgroundOpacity"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.activityRulesText.length
                    ? ruleForm.activityRulesText.length
                    : 0
                }}/2000）
              </div>
              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  :disabled="backgroundOpacity"
                >
                  生成规则
                </el-button>

                <span class="desc">
                  <i
                    class="el-alert__icon el-icon-info"
                    style="color: #999"
                  ></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        v-show="!itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_keepBtn"
        type="primary"
        size="medium"
        >保存设置</el-button
      >
    </div>
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加任务 -->
    <el-dialog
      :title="nameTitle"
      :visible.sync="dialogFormVisible"
      width="570px"
    >
      <div
        class="rulebox"
        style="
          background: #fff;
          margin-top: 0;
          margin-left: 12px;
          padding: 0;
          width: 500px;
          min-height: 254px;
        "
      >
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">阶梯：</span>
          <div style="margin-left: -55px">
            <el-select
              v-model="prizeSetting.type"
              placeholder="请选择"
              style="width: 100px"
              @change="setting"
            >
              <el-option label="指定名次" :value="1"></el-option>
              <el-option label="名次区间" :value="2"></el-option> </el-select
            >&nbsp;
            <span v-if="prizeSetting.type == 1"
              >第&nbsp;<el-input
                v-model="prizeSetting.section"
                @input="prizeSetting.section = checkNumberData($event)"
                placeholder="请填入"
                style="width: 80px"
              ></el-input>
              名</span
            >
            <span v-if="prizeSetting.type == 2">
              第&nbsp;<el-input
                v-model="prizeSetting.sectionOne"
                @input="prizeSetting.sectionOne = checkNumberData($event)"
                placeholder="请填入"
                style="width: 80px"
              ></el-input>
              名&nbsp;<span>至&nbsp;第</span>&nbsp;
              <el-input
                v-model="prizeSetting.sectionTwo"
                @input="prizeSetting.sectionTwo = checkNumberData($event)"
                placeholder="请填入"
                style="width: 80px"
              ></el-input>
              <span>&nbsp;名</span>
            </span>
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">最低邀请限制：</span>
          <div>
            最少邀请
            <el-input
              type="number"
              v-model="prizeSetting.people"
              placeholder="请填入"
              style="width: 80px"
              @input="prizeSetting.people = getNumberData($event, 0)"
            ></el-input>
            人
          </div>
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left">奖品：</span>
          <el-button @click="centerVis" style="margin-left: -55px"
            >请选择</el-button
          >
        </div>
        <div class="rulebox_flex">
          <span class="rulebox_flex_left"></span>
          <!-- 选择奖品显示 -->
          <div class="theLag" v-if="prizeSettingList.prizeType">
            <div class="theBox">
              <div
                v-if="
                  prizeSettingList.prizeType != 3 &&
                  prizeSettingList.prizeType != 10
                "
                class="flex"
                style="
                  margin: 30px 0 15px 0;
                  width: 280px;
                  justify-content: center;
                "
              >
                <div class="price_sty">
                  {{
                    prizeSettingList.prizeTxt
                      ? prizeSettingList.prizeTxt
                      : prizeSettingList.price
                  }}
                </div>
                <!-- <div class="price_sty">{{ prizeSettingList.price }}</div> -->
                <div
                  style="
                    height: 44px;
                    width: 1px;
                    background: #fe4d45;
                    opacity: 0.2;
                    margin: 0 12px;
                  "
                ></div>
                <div style="color: #999999">
                  {{ prizeSettingList.prizeType | prizeType }}
                </div>
              </div>
              <p
                v-else
                style="
                  margin: 40px 0 50px 0;
                  width: 280px;
                  text-align: center;
                  padding-left: 25px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  line-clamp: 1;
                  -webkit-box-orient: vertical;
                "
              >
                {{ prizeSettingList.title }}
              </p>
              <p class="pp">{{ prizeSettingList.prizeType | prizeType }}</p>
            </div>
            <div class="backgrd"></div>
            <el-button class="btnQx" type="primary" @click="deleteCoupon"
              >删除</el-button
            >
          </div>
        </div>

        <div
          class="rulebox_flex"
          style="justify-content: center; margin-top: 30px"
        >
          <div class="createAdd_qx pointer" @click="dialogFormVisible = false">
            取消
          </div>
          <div class="createAdd_save pointer" @click="handleSave">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      :putPrize="putPrize"
      @close="colseDialog"
      v-if="showDialog"
      :tipShow="true"
      ref="selectProduct"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>

<script>
import {
  invite,
  editInvite,
  searchInvite,
  save,
  follow,
  editfollow,
  searchfollow,
  information,
  editInformationAa,
  searchInformation,
  creatPrize,
  editPrize,
  searchPrize,
  details,
} from "@/api/integralCenter/integralTask";
import {
  jingdouList,
  allAccountList,
  redPacketList,
} from "@/api/integralCenter/prizeCenter.js";
import { uploadImage } from "@/api/sellerImageController";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product.vue";
import QRCode from "qrcodejs2";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "淘宝E卡",
  "爱奇艺会员",
  "淘宝PLUS会员",
  "现金红包",
];
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
  },
  created() {
    this.activityData = this.$route.query.activityData;
    this.localStepNum = this.activityData.id;
    console.log("this.$route.query------>", this.$route.query);
    console.log("this.localStepNum------>", this.localStepNum);
    if (this.$route.query.valueRow) {
      this.valueRow = this.$route.query.valueRow;
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.getRedParker();
    } else if (this.$route.query.copyParams) {
      // 复制
      this.isCopy = true;
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.getRedParker();
    } else {
      this.activityTimeChange();
    }
    this.getLevel();
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "1") {
        result = "优惠卷";
      } else if (num == "10") {
        result = "专属商品";
      }
      return result;
    },
  },
  data() {
    return {
      isShowSelectCrowd: false,
      peopleList: [],
      isStartEditTime: "",
      isStartEdit: false,
      flag: 0,
      isCopy: false,
      valueRow: null,
      imgUrlOne: "",
      step: 0, //  0-入会前 1-入会后
      imageUrl1: "",
      imageUrl2: "",
      indexNum: "",
      eleNumber: 1,
      //奖品设置弹框
      prizeSetting: {
        type: 2, //指定
        section: "",
        sectionOne: "",
        sectionTwo: "",
        people: "",
      },
      nameTitle: "奖品设置",
      trialList: [],
      element: "", //添加任务
      showDialog: false,
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      dialogItem: {
        eachReachMoney: "",
        orderTime: [],
        moneyType: "",
        awardMultiple: "",
        specialAwardList: [],
      },
      dialogFormVisible: false,
      picType1: 0, // 是否预设 0-系统预设 1-自定义
      telCode: "",
      localStep: 1,
      statusComment: false,
      localStepNum: 1,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      //
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      levelList: [],
      disableTime: false,
      clickActual: true,
      qrcode: null,
      order: "",
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        price: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            return (
              time.getTime() <
              new Date(this.ruleForm.activityStartTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.activityEndTime).getTime()
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      activityStartTime: null,
      activityEndTime: null,
      putPrize: {},
      ruleForm: {
        membershipTime:"",
        //设置规则表单
        cutActivityWhileNoPrize: false, // 奖品领取完毕后，活动强制结束
        activityName: "",
        partner: ["-1"],
        activityObject: 0,
        newOldCustomer: 0,

        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
        copywriting: "", //邀请文案
        deadline: "", //打榜截止时间
      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      generalCoupon: {
        // 通用优惠券
        couponType: 0,
      },
    };
  },
  watch: {
    // localStepNum(newVal) {
    //   if (newVal == 0) {
    //     this.$nextTick(() => {
    //       this.qrcodeAll(this.activityData.telCode, queryId);
    //     });
    //   }
    // },
  },
  methods: {
    checkNumberData(value) {
      if (value) {
        value = value.replace(/[^\d]/g, "");
      }
      if (value <= 0) {
        value = "";
      }
      if (value > 100) {
        value = 100;
      }
      return value;
    },

    //数据回显
    getRedParker() {
      details({ id: this.valueRow.id }).then((res) => {
        this.activityTimeValue = [
          String(res.data.startTime),
          String(res.data.endTime),
        ];
        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? Number(res.data.newOldCustomer)
          : 0;
        this.peopleList =
          res.data.hasOwnProperty("seniorGroupId") &&
          res.data.seniorGroupId.length > 0
            ? res.data.seniorGroupId.split(",")
            : [];
        if (res.data.allowLevel) {
          this.ruleForm.partner = res.data.allowLevel.split(",");
        }
        this.ruleForm.membershipTime = res.data.membershipTime
        if (this.isStartEdit) {
          //进行中活动 无法修改活动开启时间
          this.isStartEditTime = String(res.data.startTime);
        }
        let datas, change1, change2, days, daysStart, daysEnd, date3;
        daysStart = res.data.startTime.substring(0, 10);
        daysEnd = res.data.endTime.substring(0, 10);
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(res.data.endTime).getTime() -
          new Date(res.data.startTime).getTime();
        let leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
        this.picType1 = res.data.picType;
        if (res.data.picType == 1) {
          this.imageUrl1 = String(res.data.picUrl);
        }
        this.picUrl = res.data.picUrl;
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.activityRulesText = this.isCopy
          ? ""
          : String(res.data.ruleDescription); //生成规则
        this.ruleForm.isFollow =
          res.data.ruleDto.condFollow == 1 ? true : false;
        this.ruleForm.cutActivityWhileNoPrize =
          res.data.ruleDto.cutActivityWhileNoPrize == 1 ? true : false;
        this.ruleForm.copywriting = String(res.data.ruleDto.inviteText);
        this.ruleForm.deadline = String(res.data.ruleDto.deadLine);
        if (!this.isCopy) {
          this.trialList = res.data.pointActivityPrizeDTOList.map((v) => ({
            ...res.data,
            prizeSettingList: {
              price: v.price,
              title: v.title,
              assetsId: v.assetsId,
              prizeType: v.prizeType,
              logo: v.logo,
              price: v.price,
              singleAmount: v.singleAmount,
            },
            pointActivityPrizeDTOList: v,
          }));
        } else {
          this.trialList = [];
        }
        this.trialList.forEach((e, index) => {
          if (e.pointActivityPrizeDTOList.ladderType == 2) {
            var reg = /([~][^~]+)$/;
            var reg2 = /([^~]+)$/;
            var blueurl = e.pointActivityPrizeDTOList.ladderRank.replace(
              reg,
              ""
            );
            var bluefile =
              e.pointActivityPrizeDTOList.ladderRank.match(reg2)[1];
            this.trialList[index].pointActivityPrizeDTOList.sectionOne =
              blueurl;
            this.trialList[index].pointActivityPrizeDTOList.sectionTwo =
              bluefile;
          } else {
            this.trialList[index].pointActivityPrizeDTOList.section =
              e.pointActivityPrizeDTOList.ladderRank;
          }
        });
      });
    },
    //生成规则
    generateRule() {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let getNum = "";
      //活动规则判断
      let text1 = "",
        text2 = `2.活动对象：限会员`,
        text3 = `3.邀请入会的好友仅限未入会的好友；`,
        text4 = `4.被邀请的好友需要点击“立即入会助力“并且在入会弹窗中进行入会后才算助力成功`,
        text5 = "5.邀请入会好友总人数达到榜单要求后可以领取相应奖品；",
        text6 = "6.需在活动结束后进入活动页面进行奖品的领取；",
        text7 =
          "7.如出现邀请总人数相同的情况，则按照达到人数的先后顺序进行排序；",
        text8 =
          "8.若用户存在刷奖等恶意行为，一经发现将取消获奖资格（如奖品已经发放，有权追回奖品）；",
        text9 = "活动参与主体资格：",
        text10 =
          "  （1）每位自然人用户仅能使用一个天猫（淘宝）账号参与活动，手机号码等任意信息一致或指向同一用户，视为同一用户，则第一个参与本活动的账号参与结果有效，其他账号参与本活动均视为无效；",
        text11 =
          "  （2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格。",
        text12 = "注意事项：",
        text13 =
          "  （1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利。",
        text14 =
          "  （2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动。";

      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text1 =
          "1.活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime +
          ";";
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      let Arr1 = [];
      Arr1 = [
        text1,
        text2,
        text34,
        text3,
        text4,
        text5,
        text6,
        text7,
        text8,
        text9,
        text10,
        text11,
        text12,
        text13,
        text14,
      ];
      let newText = "";
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    //弹框确认
    handleDialogCloseAnoth() {
      if (this.picType1 == 0) {
        this.imageUrl1 = "";
        this.imageUrl2 = "";
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let numList = [];
      this.trialList.forEach((e, index) => {
        if (e.pointActivityPrizeDTOList.prizeType == 1) {
          if (e.pointActivityPrizeDTOList.couponType == 4) {
            e.pointActivityPrizeDTOList.couponType = 4;
          } else {
            if (this.generalCoupon.couponType == 4) {
              e.pointActivityPrizeDTOList.couponType = 4;
            } else {
              e.pointActivityPrizeDTOList.couponType = 3;
            }
          }
        }
        numList.push(e.pointActivityPrizeDTOList);
      });
      let params = {
        activityName: this.ruleForm.activityName,
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        pointActivityPrizeDTO: {},
        pointActivityPrizeDTOList: numList,
        picType: this.picType1,
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.peopleList.join(","),
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        picUrl: this.imageUrl1
          ? this.imageUrl1
          : this.imageUrl2
          ? this.imageUrl2
          : "",
        ruleDTO: {
          condFollow: this.ruleForm.isFollow == true ? 1 : 0, //参与条件,
          inviteText: this.ruleForm.copywriting,
          deadLine: this.ruleForm.deadline,
          cutActivityWhileNoPrize: this.ruleForm.cutActivityWhileNoPrize
            ? 1
            : 0,
        },
        ruleDescription: this.ruleForm.activityRulesText,
      };
      if (this.$route.query.valueRow && !this.isCopy) {
        params.id = this.valueRow.id;
      }
      if (this.checked == true) {
        save(params).then((res) => {
          if (res.code == 1) {
            this.$router.push({ path: "activeList" });
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    // 上传图片
    beforeUpload1(file) {
      if (this.isStartEdit) return;
      let _this = this;
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size < 2097152;
      if (!(isJPG || isPNG || isJPEG)) {
        this.$message.error("上传图片只能是JPG和PNG格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      let forms = new FormData();
      forms.append("file", file);
      uploadImage(forms).then((res) => {
        this.imgUrlOne = res.data;
        if (this.step === 0) {
          this.imageUrl1 = res.data;
        } else if (this.step === 1) {
          this.imageUrl2 = res.data;
        }
        console.log(res, 1);
      });
      return !(isJPG || isPNG || isJPEG) && isLt2M;
    },
    setting(e) {
      this.prizeSetting.tpye = e;
    },
    //入会打榜保存修改
    saveEdit() {
      if (this.ruleForm.activityEndTime && this.ruleForm.deadline) {
        let time1 = new Date(this.ruleForm.activityEndTime).getTime();
        let time2 = new Date(this.ruleForm.deadline).getTime();
        let timeDiff = Math.abs(time2 - time1);
        let hoursDiff = timeDiff / (1000 * 60 * 60);
        if (hoursDiff < 48 || time1 - time2 < 0) {
          // console.log('两个时间相差48小时以内');
          this.$message.warning("打榜截止时间要在活动结束时间之前至少48小时！");
          return;
        } else {
          // console.log('两个时间相差超过48小时');
        }
      }
      this.joinBlackList = true;
    },
    //选择奖品
    centerVis(scope) {
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(this.prizeSettingList)
      });
    },
    //添加任务
    addTask() {
      this.dialogFormVisible = true;
      this.prizeSetting.sectionOne = "";
      this.prizeSetting.sectionTwo = "";
      this.prizeSettingList = {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        price: "",
        singleAmount: "",
      };
      this.prizeSetting = {
        type: 2, //指定
        section: "",
        sectionOne: "",
        sectionTwo: "",
        limit: true,
        people: "",
      };
      this.nameTitle = "奖品设置";
    },
    //确定
    handleSave() {
      console.log(this.prizeSetting.type, "123546");
      //Note条件判断
      if (this.prizeSetting.type == 1) {
        if (this.prizeSetting.section == "") {
          this.$message.warning("请输入指定名次");
          return;
        }
      } else if (this.prizeSetting.type == 2) {
        if (
          this.prizeSetting.sectionOne == "" ||
          this.prizeSetting.sectionTwo == ""
        ) {
          this.$message.warning("请输入完整名次区间");
          return;
        }
      }
      if (this.prizeSetting.people == "") {
        this.$message.warning("请输入最少邀请人数");
        return;
      }
      let rank = "";
      if (this.prizeSetting.type == 1) {
        rank = this.prizeSetting.section;
        this.prizeSetting.sectionOne = "";
        this.prizeSetting.sectionTwo = "";
      } else {
        rank =
          this.prizeSetting.sectionOne + "~" + this.prizeSetting.sectionTwo;
      }
      let parm = {
        prizeSettingList: this.prizeSettingList,
        price: this.prizeSettingList.price,
        title: this.prizeSettingList.title,
        prize: this.prizeSettingList.logo,
        section: this.prizeSetting.section,
        sectionOne: this.prizeSetting.sectionOne,
        sectionTwo: this.prizeSetting.sectionTwo,
        people: this.prizeSetting.people,
        pointActivityPrizeDTOList: {
          totalAmount: 1,
          prizeIndex: this.eleNumber, //序号
          ladderType: this.prizeSetting.type, //阶梯排名
          ladderRank: rank,
          inviteLimit: this.prizeSetting.people,
          title: this.prizeSettingList.title,
          price: this.prizeSettingList.price,
          assetsId: this.prizeSettingList.assetsId,
          singleAmount: this.prizeSettingList.singleAmount,
          prizeType: this.prizeSettingList.prizeType,
          logo: this.prizeSettingList.logo,
          sectionOne: this.prizeSetting.sectionOne,
          sectionTwo: this.prizeSetting.sectionTwo,
          section: this.prizeSetting.section,
          couponType: this.prizeSettingList.couponType,
        },
      };
      console.log(parm, "====>parm");

      if (this.generalCoupon.couponType == 4) {
        parm.pointActivityPrizeDTOList.batchKey = this.generalCoupon.batchKey;
        parm.pointActivityPrizeDTOList.couponType =
          this.generalCoupon.couponType;
      }
      if (this.nameTitle == "奖品设置") {
        //试用商品
        this.element++;
        this.eleNumber++;
        this.element = parm;
        this.setPrizeTxt(this.prizeSettingList);
        this.trialList.push(this.element);
      } else {
        console.log(
          this.trialList[this.indexNum].pointActivityPrizeDTOList.ladderType,
          this.prizeSetting.type,
          22222
        );
        //编辑更新
        this.trialList[this.indexNum].pointActivityPrizeDTOList.ladderType =
          this.prizeSetting.type;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.ladderRank =
          this.prizeSetting.section;
        if (
          this.trialList[this.indexNum].pointActivityPrizeDTOList.ladderType ==
          2
        ) {
          this.trialList[this.indexNum].pointActivityPrizeDTOList.ladderRank =
            this.prizeSetting.sectionOne + "~" + this.prizeSetting.sectionTwo;
        }
        this.trialList[this.indexNum].pointActivityPrizeDTOList.section =
          this.prizeSetting.section;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.ladderType =
          this.prizeSetting.type;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.sectionOne =
          this.prizeSetting.sectionOne;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.sectionTwo =
          this.prizeSetting.sectionTwo;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.inviteLimit =
          this.prizeSetting.people;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.title =
          this.prizeSettingList.title;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.logo =
          this.prizeSettingList.logo;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.price =
          this.prizeSettingList.price;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.singleAmount =
          this.prizeSettingList.singleAmount;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.assetsId =
          this.prizeSettingList.assetsId;
        this.trialList[this.indexNum].pointActivityPrizeDTOList.prizeType =
          this.prizeSettingList.prizeType;
        if (this.generalCoupon.couponType == 4) {
          this.trialList[this.indexNum].pointActivityPrizeDTOList.batchKey =
            this.generalCoupon.batchKey;
          this.trialList[this.indexNum].pointActivityPrizeDTOList.assetsId =
            null;
        }
      }
      this.dialogFormVisible = false;
    },
    //选择商品数据 曝光
    getTheData(data, prizeType) {
      if (data.couponType == 4) {
        this.generalCoupon = JSON.parse(JSON.stringify(data));
      } else {
        this.generalCoupon = { couponType: 0 };
      }
      this.colseDialog();
      this.showDialog = false;
      // 判断通用优惠券
      if (this.generalCoupon.couponType == 4) {
        this.prizeSettingList.singleAmount = 1;
        this.prizeSettingList.assetsId = null;
        this.prizeSettingList.prizeType = data.prizeType;
        this.prizeSettingList.title = data.price;
        this.prizeSettingList.price = data.price;
        this.prizeSettingList.couponType = data.couponType;
        this.prizeSettingList.batchKey = data.batchKey;
      } else {
        this.prizeSettingList.singleAmount = 1;
        this.prizeSettingList.assetsId = Number(data.couponId);
        this.prizeSettingList.prizeType = prizeType;
        this.prizeSettingList.logo = data.logo;
        this.prizeSettingList.title = data.name || prizeType;
        this.prizeSettingList.price = data.discount;
      }
      if (prizeType == 4) {
        //Note旧
        //this.prizeSettingList.title = prizeType;
        this.prizeSettingList.title = data.discount + "店铺积分";
        this.prizeSettingList.price = data.discount;
        this.prizeSettingList.singleAmount = data.singleAmount;
      } else if (prizeType == 2) {
        this.prizeSettingList.singleAmount = data.singleAmount;
        this.prizeSettingList.couponType = data.couponType;
        this.prizeSettingList.title = prizeType;
        this.prizeSettingList.quantityTotal = data.quantityTotal;
      } else if (prizeType == 10) {
        this.prizeSettingList.title = data.itemTitle;
        this.prizeSettingList.logo = data.picUrl;
        this.prizeSettingList.assetsId = data.id;
        this.prizeSettingList.price = data.price;
      }
      this.setPrizeTxt(this.prizeSettingList);
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = true;
    },
    //删除
    deletePacket(params) {
      if (this.isStartEdit) return;
      this.trialList.splice(params, 1);
      this.eleNumber--;
    },
    //编辑
    edit(e, index) {
      if (this.isStartEdit) return;
      this.indexNum = index;
      this.flag = 1;
      console.log("5236", index, e);
      this.nameTitle = "编辑奖品设置";
      this.prizeSettingList = e.prizeSettingList;
      this.prizeSetting = {
        type: e.pointActivityPrizeDTOList.ladderType,
        people: e.pointActivityPrizeDTOList.inviteLimit,
        sectionOne: e.pointActivityPrizeDTOList.sectionOne,
        sectionTwo: e.pointActivityPrizeDTOList.sectionTwo,
        section: e.pointActivityPrizeDTOList.section,
      };
      // if(e.pointActivityPrizeDTOList.ladderType ==2){
      //   var reg = /([~][^~]+)$/;
      //   var reg2 = /([^~]+)$/;
      //   var blueurl = e.pointActivityPrizeDTOList.ladderRank.replace(reg, "");
      //   var bluefile = e.pointActivityPrizeDTOList.ladderRank.match(reg2)[1];
      //   this.prizeSetting.sectionOne = blueurl;
      //   this.prizeSetting.sectionTwo = bluefile;
      // }else{
      //   this.prizeSetting.section=e.pointActivityPrizeDTOList.ladderRank
      // }
      this.dialogFormVisible = true;
    },
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
    itemDel(index) {
      if (this.tableData.length == 1) {
        this.$message.warning("梯度奖品必须有一个奖项");
        return;
      }
      this.tableData.splice(index, 1);
      console.log(this.tableData);
    },
    addPrizeRule() {
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        value: "",
        prizeCount: "",
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      console.log(filtered, e.target.value, this.ruleForm.peopleCount);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else if (
        item.prizeType == 7 ||
        item.prizeType == 6 ||
        item.prizeType == 5
      ) {
        item.prizeTxt = item.price;
      } else {
        if (item.couponType == 4) {
          item.prizeTxt = item.price + "元";
        } else {
          item.prizeTxt = item.singleAmount;
        }
      }
    },
    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    // 检查奖品总数
    async checkedPrizeCount(item) {
      await this.setPromise(item);
    },
    setPromise(item) {
      if (item.priceType == 2) {
        return new Promise((resolve, reject) => {
          const formLitJD = {
            current: 1,
            size: 100,
            isFilterUsed: true,
            status: 2,
          };
          jingdouList(formLitJD)
            .then((res) => {
              res.filter((i) => {
                // 对应的计划
                if (i.id == item.assetsId) {
                  // 奖品总份数为空
                  if (!item.totalAmount) {
                  }
                }
              });
              resolve(res);
            })
            .catch((res) => {});
        });
      }
    },
    // getJingdouList() {
    //   jingdouList(this.formLitJD)
    //     .then((res) => {
    //       let selectArr = res.data.records.map((item) => {
    //         return {
    //           label: item.planName,
    //           value: item.id,
    //         };
    //       });
    //       this.selectList = selectArr;
    //       this.planList.jingdou = res.data.records
    //     })
    //     .catch((res) => {});
    // },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
        // this.itemListFor.splice(i, 1);
      }
      console.log(this.mainImagelist, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();
      if (this.backgroundOpacity) {
        var datas, change1, change2, days, daysStart, daysEnd, date3;
        daysStart = this.ruleForm.activityStartTime.substring(0, 10);
        daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
        if (
          this.ruleForm.activityEndTime != "" &&
          this.ruleForm.activityStartTime != ""
        ) {
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(this.ruleForm.activityEndTime).getTime() -
            new Date(this.ruleForm.activityStartTime).getTime();
          var leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
        } else {
          this.timeOut = 0;
          return;
        }
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (start < nowTime) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          if (!this.isStartEdit) {
            this.$message.warning("开始时间不能小于当前时间");
          }
          // this.ruleForm.activityStartTime = null;
          // return;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.activityEndTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.activityEndTime = null;
        return;
      }
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (
        this.ruleForm.activityEndTime != "" &&
        this.ruleForm.activityStartTime != ""
      ) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
      if (
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityEndTime.substring(0, 10) ==
          this.ruleForm.activityStartTime.substring(0, 10)
      ) {
        this.$message.warning("活动时间不能小于一天");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },

    // 下一步
    resetForm() {
      this.joinBlackList = true;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // debugger
      // this.$refs.selectGo.handleRightCurrentChange(1);
      // console.log(this.selectGoodsArr);
      // return
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      // console.log(data);
      // // debugger
      // if (data) {
      //   console.log(data);
      //   this.itemListFor = [];
      //   this.mainImagelist = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     this.itemListFor.push(fomeVaule);
      //     this.mainImagelist.push(fomeVaule);
      //   });
      //   this.selectGoodsArr = this.itemListFor;
      // }
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    // 返回上一步
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
      // if (this.backgroundOpacity) {
      //   this.$emit("returnBack");
      //   return;
      // }
      // this.localStep = 0;
      // this.localStepNum = 0;
      // this.$emit("titopName", this.activityData.name, false);
    },
    checkputnCount(e, row) {
      if (row.quantityTotal && row.price && row.prizeCount) {
        let numTotal = this.$jingdouTotal(row);
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.prizeCount;
      }
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.warningTitele {
  width: 520px;
  height: 42px;
  background: #fdf6ec;
  border-radius: 4px;
  line-height: 42px;
  display: block;
  padding-left: 15px;
  margin: 10px 0 6px;
}

.theLag {
  position: relative;
  margin-top: 10px;
  height: 142px;
  width: 302px;
  margin-left: -100px;
  .theBox {
    height: 142px;
    width: 302px;
    // border: 1px solid #999;
    background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
    border-radius: 8px;
    position: absolute;
    color: #333333;
    .price_sty {
      font-family: DIN;
      font-weight: bold;
      color: #2670fb;
      font-size: 45px;
    }
    .pp {
      width: 280px;
      text-align: center;
      bottom: 0px;
    }
  }
  .btnQx {
    display: none;
  }
  &:hover {
    .btnQx {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -16px 0 0 -49px;
    }
    .backgrd {
      width: 302px;
      height: 142px;
      background: #fff;
      position: absolute;
      border-radius: 8px;
      opacity: 0.7;
    }
  }
}
.wide {
  width: 750px;
  height: auto;
  background: #f8f9ff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  line-height: 23px;
  margin-bottom: 10px;
  padding: 20px;
  padding-bottom: 5px;
  color: #666666;
  position: relative;
  .posi {
    position: absolute;
    right: 24px;
    top: 22px;
  }
}
.imgUpload {
  display: flex;
  align-items: center;
}
/deep/.stepBox .el-step.is-horizontal .el-step__line {
  left: 155px;
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 230px;
  line-height: 230px;
  text-align: center;
}
/deep/.avatar {
  width: 130px;
  height: 230px;
  display: block;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.startTime {
  /deep/ .el-table__body-wrapper {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68);
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 625px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  border-radius: 6px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      height: 142px;
      width: 302px;
      .theBox {
        height: 142px;
        width: 302px;
        background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .price_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }

      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 302px;
          height: 142px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .desc {
      i {
        opacity: 0.7;
        color: #fe4d45;
      }
      color: #999;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      transition: all 0.2s;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.rulebox {
  width: 750px;
  min-height: 300px;
  background: #f8f9ff;
  border-radius: 8px;
  margin-top: 10px;
  padding: 24px;
  &_flex {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    &_left {
      width: 100px;
    }
    &_btn {
      padding: 0px 10px;
      height: 32px;
      color: #2670fb;
      line-height: 32px;
      background: rgba(38, 112, 251, 0.1);
      border-radius: 4px;
      border: 1px solid #2670fb;
    }
  }
  .createAdd_save {
    margin-top: 24px;
    width: 100px;
    height: 32px;
    background: #2670fb;
    margin-right: 20px;
    border-radius: 4px;
    color: #fff;
    line-height: 32px;
    text-align: center;
    &:hover {
      opacity: 0.8;
    }
  }
  .createAdd_qx {
    margin-top: 24px;
    width: 100px;
    height: 32px;
    background: #fff;
    margin-right: 20px;
    border-radius: 4px;
    color: #606266;
    line-height: 32px;
    text-align: center;
    border: 1px solid #dddddd;
    &:hover {
      color: #fff;
      background: #2670fb;
      border: 1px solid #2670fb;
    }
  }
}
</style>
